import AttachMoneyOutlinedIcon from '@mui/icons-material/AttachMoneyOutlined'
import EventNoteIcon from '@mui/icons-material/EventNote'
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined'
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined'
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined'
import { BottomNavigation, BottomNavigationAction, Paper } from '@mui/material'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link, useLocation } from 'react-router-dom'

import { useAuthContext } from '../../auth/hooks/useAuthContext'
import routes from '../../router/routes'

const ENV_NAME = import.meta.env.VITE_ENVIRONMENT_NAME
const IS_DEV_OR_STAGING = ENV_NAME === 'staging' || ENV_NAME === 'development'

const BottomNav = () => {
  const [value, setValue] = useState<number>(0)
  const { t } = useTranslation()
  const { userStatus } = useAuthContext()

  const location = useLocation()

  useEffect(() => {
    const currentLocation = location.pathname.split('/')
    const currentPath = currentLocation[currentLocation.length - 1]

    switch (currentPath) {
      case 'documents':
        setValue(2)
        break
      case 'earnings':
        setValue(1)
        break
      case 'profile':
        setValue(4)
        break
      case 'rides':
        setValue(1)
        break
      case 'schedule':
        setValue(0)
        break
      case 'training':
        setValue(3)
        break
      default:
        setValue(5)
        break
    }
  }, [location])

  return (
    <Paper
      elevation={3}
      sx={{
        bottom: 0,
        left: 0,
        position: 'fixed',
        right: 0,
        zIndex: 10,
      }}
    >
      <BottomNavigation
        onChange={(event, newValue) => {
          setValue(newValue)
        }}
        showLabels
        value={value}
      >
        {IS_DEV_OR_STAGING && (
          <BottomNavigationAction
            component={Link}
            disabled={userStatus?.status !== 'active'}
            icon={<EventNoteIcon />}
            label={t('navigation.schedule')}
            sx={{ ...(userStatus?.status !== 'active' && { opacity: 0.38 }) }}
            to={routes.portal.schedule}
          />
        )}
        <BottomNavigationAction
          component={Link}
          icon={<AttachMoneyOutlinedIcon />}
          label={t('navigation.earnings')}
          to={routes.portal.earnings}
        />
        <BottomNavigationAction
          component={Link}
          icon={<InsertDriveFileOutlinedIcon />}
          label={t('navigation.documents')}
          to={routes.portal.documents}
        />
        <BottomNavigationAction
          component={Link}
          icon={<SchoolOutlinedIcon />}
          label={t('navigation.training')}
          to={routes.portal.training}
        />
        <BottomNavigationAction
          component={Link}
          icon={<PersonOutlineOutlinedIcon />}
          label={t('navigation.profile')}
          to={routes.portal.profile}
        />
      </BottomNavigation>
    </Paper>
  )
}

export default BottomNav
